function OrderForm() {
  return <div><h2>Create Order</h2><p>Order creation form will go here.</p></div>;
}
export default OrderForm; 